export const toTitleCase = (str) => {
  return str.replace(/\b\w/g, (char) => char.toUpperCase())
}

export const toCapitalCase = (str) => {
  if (!str) return ''
  str = str.toString()
  return str.charAt(0).toUpperCase() + str.slice(1)
}



// WEBPACK FOOTER //
// ./src/utils/transformCase.js